import React, { useEffect } from "react";
import Header from "../../components/Header";
import ContactForm from "./ContactForm";
import Footer from "../Footer/Footer";

const ContactMainPage = (props) => {

    return (
        <div>
            <Header className={'contact-us'}/>
            <ContactForm />
            <Footer />
        </div>
    )
}

export default ContactMainPage;